import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pricing-group-card mb-3",
      class: { collapsed: _vm.collapsedView },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "pricing-group-header d-flex justify-space-between align-center px-2 py-2",
          on: {
            click: function ($event) {
              !_vm.collapsedView && _vm.toggleExpand()
            },
          },
        },
        [
          _c("workpackage-pg-summary", {
            attrs: {
              unit: _vm.unit,
              "is-selectable": _vm.isSelectable,
              "prevent-unit-selection": _vm.preventUnitSelection,
              "collapsed-view": _vm.collapsedView,
            },
          }),
          _vm._v(" "),
          !_vm.collapsedView
            ? _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _vm.isSelectable
                    ? _c(VCheckbox, {
                        staticClass: "my-0 mr-1 pa-0",
                        attrs: {
                          value: _vm.hasSelectedAll,
                          "hide-details": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.selectAllCategories()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(VIcon, [
                    _vm._v(
                      _vm._s(
                        _vm.isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                      )
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(VExpandTransition, [
        !_vm.collapsedView && _vm.isExpanded
          ? _c("div", { staticClass: "pricing-group-content" }, [
              _vm.unitCategories.length
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-wrap" },
                    _vm._l(_vm.unitCategories, function (category, catIndex) {
                      return _c(
                        "div",
                        {
                          key: catIndex,
                          staticClass:
                            "category-item pa-3 d-flex justify-space-between align-center",
                        },
                        [
                          _c("div", [
                            _vm._v(_vm._s(category.levelEntryDescription)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _vm.isSelectable
                                ? _c(VCheckbox, {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      value: category.levelEntryKey,
                                      "hide-details": "",
                                    },
                                    on: { change: _vm.updateCategories },
                                    model: {
                                      value: _vm.localCategories,
                                      callback: function ($$v) {
                                        _vm.localCategories = $$v
                                      },
                                      expression: "localCategories",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isSelectable
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex" },
                                    [
                                      _c("approval-icon-new", {
                                        staticClass: "pr-1",
                                        attrs: {
                                          "tooltip-message": _vm.$t(
                                            "gridView.tooltips.categoryManagerApproval"
                                          ),
                                          approved: _vm.isCategoryApproved(
                                            category,
                                            "categoryManagerApproval"
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("approval-icon-new", {
                                        attrs: {
                                          "tooltip-message": _vm.$t(
                                            "gridView.tooltips.pricingSpecialistApproval"
                                          ),
                                          approved: _vm.isCategoryApproved(
                                            category,
                                            "pricingSpecialistApproval"
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "pa-3 text-center grey--text" }, [
                    _vm._v("\n        No categories available\n      "),
                  ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }